interface OpenFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  label: string;
}

// Campo abierto: siempre opcional (handoff §8).
export function OpenField({ value, onChange, placeholder, label }: OpenFieldProps) {
  return (
    <div className="gb-open">
      <textarea
        className="gb-open__field"
        rows={4}
        value={value ?? ''}
        placeholder={placeholder ?? 'Escribe aquí…'}
        aria-label={label}
        maxLength={2000}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="gb-open__hint">Esta pregunta es opcional. Puedes continuar sin responderla.</p>
    </div>
  );
}
